'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonationTotals = exports.fetchDonationTotals = undefined;

var _client = require('../../../utils/client');

var _client2 = _interopRequireDefault(_client);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _campaigns = require('../../campaigns');

var _params = require('../../../utils/params');

var _currencies = require('../../../utils/currencies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchDonationTotals = exports.fetchDonationTotals = function fetchDonationTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  switch ((0, _params.dataSource)(params)) {
    case 'event':
      return _client2.default.get('v1/event/' + (0, _params.getUID)(params.event) + '/leaderboard', {
        currency: (0, _currencies.currencyCode)(params.country)
      });
    case 'charity':
      // No API method supports total funds raised for a charity
      return (0, _params.required)();
    default:
      return (0, _campaigns.fetchCampaign)((0, _params.getUID)(params.campaign));
  }
};

var deserializeDonationTotals = exports.deserializeDonationTotals = function deserializeDonationTotals(totals) {
  return {
    raised: totals.totalRaised || totals.raisedAmount || (0, _get2.default)(totals, 'donationSummary.totalAmount') || 0,
    donations: totals.numberOfDirectDonations || (0, _get2.default)(totals, 'donationSummary.totalNumberOfDonations') || 0
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/donation-totals/justgiving/index.js
// module id = 1312
// module chunks = 0